import styles from "../shop.module.css";

// Thin banner above Shop Now (e.g. "MINIMUM PURCHASE OF £30"), set in Shop > Shop Settings
const AnnouncementBar = ({ text }) => {
  if (!text || !String(text).trim()) return null;
  return <div className={styles.Announcement} role="note">{text}</div>;
};

export default AnnouncementBar;
